import { useAsyncExecutor2, useAsyncExecutorPool } from "async-executor-hook";
import { stringify } from "query-string";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  FormControl,
  FormGroup,
  useFormConfig,
  WForm,
  WFormControl,
} from "rectangular-forms";

import { Authorization } from "../../common/AuthorizationCpt";
import {
  WInputText,
  WMultiSelect,
} from "../../common/components/TemplateContainer/InputTemplates";
import { SaveButton } from "../../common/components/TemplateContainer/SaveButton";
import { TemplateInputContainer } from "../../common/components/TemplateContainer/TemplateContainer";
import IconVectorRightBlue from "../../images/icon_button_users_blue.svg";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import {
  ContainerProfile,
  Header,
  UsersContainer,
} from "./UsersManagementStyles";

const UsersManagementSearch = (props) => {
  const { params$, userProfileMe, loadUsers } = props;
  const history = useHistory();
  const formConfig = useFormConfig({
    createForm: (data) => {
      const form = new FormGroup({
        user_info: new FormControl(),
        profiles: new FormControl([]),
      });
      form.patchValue(data);
      return form;
    },
    onSubmit: (form) => {
      const data = form.value;
      history.push(`/web/importaciones/usuarios?${stringify(data)}`);
    },
  });
  useAsyncExecutor2((params) => params, {
    params$,
    onSuccess: (params) => {
      formConfig.loadSucceed(params);
    },
  });
  const asyncExecutorPoolProfileAgent = useAsyncExecutorPool("");
  const loadRoleProfilesAgent: any = asyncExecutorPoolProfileAgent.getExecutor(
    "loadRolProfilesUserAgent"
  );
  const loadProfileAgent = useAsyncExecutor2(
    () => {
      return networkBackendRequest(`/roles/`, HTTP_METHODS.GET, {}).then(
        (response) => response.json()
      );
    },
    {
      onSuccess: () => {},
    }
  );
  useEffect(() => {
    loadProfileAgent.execute({});
    // eslint-disable-next-line
  }, []);

  const filterRolProfiles = loadRoleProfilesAgent?.data?.roles
    .find((role) => role.name === userProfileMe.role.name)
    .profiles.map((profile) => {
      return {
        label: `${profile.name} de ${userProfileMe.role.name}`,
        value: `${profile.id}`,
      };
    });

  const profilesLength = formConfig?.form?.value.profiles.length > 3;

  return (
    <div>
      <Authorization actions={["user.get_users"]}>
        <UsersContainer>
          <Header>USUARIOS</Header>
          <WForm formConfig={formConfig}>
            <div
              className="p-grid"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div className="p-col-12 p-md-4">
                <WFormControl name="user_info">
                  <TemplateInputContainer label="Usuario:" color="#08082B">
                    <WInputText
                      width="100%"
                      height="5rem"
                      fontSize="1.4rem"
                      placeholder="Nombre o número de documento"
                    />
                  </TemplateInputContainer>
                </WFormControl>
              </div>
              <ContainerProfile
                className="p-col-12 p-md-5"
                profilesLength={profilesLength}
              >
                <Authorization actions={["role.get_roles_and_profiles"]}>
                  <WFormControl name="profiles">
                    <TemplateInputContainer label="Perfil:" color="#08082B">
                      <WMultiSelect
                        options={filterRolProfiles || []}
                        width={`${profilesLength ? "33vw" : "100%"}`}
                        placeholder="Seleccione Perfil"
                      />
                    </TemplateInputContainer>
                  </WFormControl>
                </Authorization>
              </ContainerProfile>
              <div
                className="p-col-12 p-md-3"
                style={{
                  display: "flex",
                  alignItems: "end",
                }}
              >
                <SaveButton
                  label="Aplicar filtros"
                  iconRight={IconVectorRightBlue}
                  isLoading={loadUsers.isLoading}
                  width="100%"
                  height="5rem"
                  fontSize="1.5rem"
                  backgroundColor="#002E6C"
                />
              </div>
            </div>
          </WForm>
        </UsersContainer>
      </Authorization>
    </div>
  );
};

export default UsersManagementSearch;
